import { useState, useContext } from 'react';
import 'assets/scss/components/upsell.scss';
import UpsellItem from './upsell/UpsellItem.jsx';
import { EmbedSiteShortContext } from 'App.js';

// logos
import logoLargeChillblast from 'assets/img/chillblast-logo-white.svg';
import logoLargeCCLDark from 'assets/img/ccl_logo_chevron_dark_lime.png';

export default function Upsell({ products })
{
    const runningInDev = process.env.NODE_ENV === 'development' ? true : false;
    const site = useContext(EmbedSiteShortContext);

    let [scrolledTop, setScrolledTop] = useState(false);

    let logoWidth = 200;
    let logo = "";

    // svg files need to be prefixed with the assetBaseUrl as react doesn't convert them to base64 like other images under 8KB
    // png files under 8KB will get converted to base64 by webpack
    switch (site)
    {
        case "chillblast":
            logo = runningInDev ? logoLargeChillblast : process.env.REACT_APP_ASSET_BASE_URL + logoLargeChillblast;
            break;
        case "ccl":
            logo = logoLargeCCLDark;
            break;                   
      default:
    }

    //#region Event Handlers

    const handleGoToCheckout = () =>
    {
        window.location.href = "/basket";
    }

    //#endregion Event Handlers

    if (!scrolledTop)
    {
        window.scrollTo(0, 0);
        setScrolledTop(true);
    }

    return (

        <div className="upsell-wrapper vh-100">

            <div className="upsell-container mb-auto">

                <div className="container pt-2 custom-bg-dark">

                    {/*header*/}
                    <div className="row">

                        <div className="col py-3 py-md-5">

                            <picture>
                                <img className="header-logo d-block mx-auto mx-md-0" width={logoWidth} src={logo} alt="Logo"></img>
                            </picture>

                            <h1 className="mt-3 mb-0 text-center text-md-start custom-color-light">Your custom PC has been successfully added to your basket</h1>

                        </div>

                        <div className="col-12 col-md-auto py-3 py-md-5 d-flex align-items-center">

                            <button type="button" className="primary-button text-casing p-3 mx-auto mx-md-0 custom-color-dark" onClick={handleGoToCheckout}>Continue to Checkout</button>

                        </div>

                    </div>

                    <hr />

                    {/*body*/}
                    {
                        (products && products.length > 0) &&
                        <>
                            <h1 className={"mb-4 mt-4 mb-md-4 mt-md-5" + (site === "chillblast" ? " text-light" : "")}>Perfect with your new PC...</h1>

                            <div className="row">
                                {
                                    products.map((product) =>

                                        <div key={"product_" + product.productID} className="col-md-6 col-lg-3 mb-3">

                                            <UpsellItem keyFor={product.productID} product={product} />

                                        </div>
                                    )
                                }
                            </div>
                        </>
                    }

                </div>

            </div>

        </div>

    );
}